import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import s from './Feedback.scss';
import {INFO_TEXT, FEEDBACK_TYPES, FEEDBACK_VALIDATIONS} from './FeedbackConstants'
import {actionCreators as analyticsActionCreators} from '../../redux/actions/analyticsActions';
import DataSet from '../../utils/DataSet';
import HbButton from '../../components/HbButton/HbButton';
import HbIcon from '../../components/Icon/HbIcon';
import HbReview from '../../components/Textarea/HbReview';

class Feedback extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    wrapperClassName: PropTypes.string,
    buttonContainerClassName: PropTypes.string
  }

  static defaultProps = {
    isMobile: true
  }

  componentDidUpdate(prevProps) {
    this.setState({
      removeDom: false,
    });

    if (prevProps.appliedFacetArray !== this.props.appliedFacetArray || this.props.queryParams.sayfa !== prevProps.queryParams.sayfa) {
      this.setState({
        ...this.getInitialState(),
        removeDom: true,
      });
    }
  }

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => {
    return {
      showCheckMark: false,
      infoText: INFO_TEXT.DID_YOU_FIND_WHAT_YOU_ARE_LOOKING_FOR,
      showFeedbackButtons: true,
      showFeedbackArea: false,
      letterCount: FEEDBACK_VALIDATIONS.MAX_DESCRIPTION_LENGTH,
      errorMessages: null,
      feedbackDetailText: '',
      displayErrorMessage: false,
      removeDom: false,
    };
  }

  updateValue = (event) => {
    this.setState({
      letterCount: FEEDBACK_VALIDATIONS.MAX_DESCRIPTION_LENGTH - event.target.value.length,
      feedbackDetailText: event.target.value,
    });
  }

  sendFeedbackHbusClickEvent = (response, actionType = null, description = null) => {
    const {dispatch, pageTypeForDavinci, pageValueForDavinci} = this.props;

    dispatch(
      analyticsActionCreators.sendFeedbackClickEvent.trigger({
        actionType: actionType,
        clickedResponse: response,
        description: description,
        pageType: pageTypeForDavinci || window?.hepsiBus?.parsers?.getPageType() || '',
        pageValue: pageValueForDavinci || window?.hepsiBus?.parsers?.getPageValue() || '',
      })
    );
  }

  cancelComment = () => {
    let validTextForDavinci = this.state.feedbackDetailText.trim().replace(FEEDBACK_VALIDATIONS.DISALLOWED_CHARACTERS_REGEX, FEEDBACK_VALIDATIONS.DISALLOWED_CHARACTERS_REPLACEMENT);
    this.sendFeedbackHbusClickEvent(FEEDBACK_TYPES.NO, FEEDBACK_TYPES.CANCEL, validTextForDavinci === '' ? null : validTextForDavinci);
    this.displaySuccessMessage();
  }

  displaySuccessMessage = () => {
    this.setState({
      showFeedbackArea: false,
      showCheckMark: true,
      infoText: INFO_TEXT.THANK_YOU_FOR_YOUR_FEEDBACK,
    });
  }

  positiveFeedback = () => {
    this.sendFeedbackHbusClickEvent(FEEDBACK_TYPES.YES);
    this.setState({
      showFeedbackButtons: false,
    });

    this.displaySuccessMessage();
  }

  negativeFeedback = () => {
    this.sendFeedbackHbusClickEvent(FEEDBACK_TYPES.NO);
    this.setState({
      showFeedbackButtons: false,
      showFeedbackArea: true,
      infoText: INFO_TEXT.TYPE_YOUR_FEEDBACK_BELOW,
    });
  }

  sendFeedback = () => {
    const validation = this.feedbackValidation();

    if (validation.hasError) {
      const message = validation.errorList.join('<br/>');
      this.setState({
        displayErrorMessage: true,
      });
      return message;
    }

    let validTextForDavinci = this.state.feedbackDetailText.trim().replace(FEEDBACK_VALIDATIONS.DISALLOWED_CHARACTERS_REGEX, FEEDBACK_VALIDATIONS.DISALLOWED_CHARACTERS_REPLACEMENT);
    this.sendFeedbackHbusClickEvent(FEEDBACK_TYPES.NO, FEEDBACK_TYPES.SEND, validTextForDavinci === '' ? null : validTextForDavinci);

    this.displaySuccessMessage();
    return '';
  }

  validate = (value) => {
    const errorList = [];

    if (value) {
      if (value.length < FEEDBACK_VALIDATIONS.MIN_DESCRIPTION_LENGTH) {
        errorList.push(FEEDBACK_VALIDATIONS.MIN_CHARACTER_LIMIT_ERROR);
      } else if (value.length > FEEDBACK_VALIDATIONS.MAX_DESCRIPTION_LENGTH) {
        errorList.push(FEEDBACK_VALIDATIONS.MAX_CHARACTER_LIMIT_ERROR);
      } else {
        const regex = new RegExp(FEEDBACK_VALIDATIONS.INVALID_DESCRIPTION_REGEX);
        if (!regex.exec(value)) {
          errorList.push(FEEDBACK_VALIDATIONS.INVALID_DESCRIPTION_ERROR);
        }
      }
    }

    return errorList;
  }

  feedbackValidation = () => {
    let body = this.state.feedbackDetailText.trim();

    let errorList = [].concat(
      this.validate(body)
    );

    this.setState({
      errorMessages: errorList[0],
    });

    return {
      hasError: errorList.length > 0,
      errorList: errorList,
    };
  }

  sendGoogleAnalytics = (type) => {
    return JSON.stringify({
      events: {click: ['ga']},
      data: {
        category: 'Listing',
        event: 'User Feedback',
        label: type,
        withCustomEventName: true,
      },
      type: 'standart',
    });
  }

  render() {
    const {showCheckMark, infoText, showFeedbackButtons, showFeedbackArea, letterCount, errorMessages, displayErrorMessage, removeDom} = this.state;
    const {pageTypeForDavinci, pageValueForDavinci, isMobile, className, wrapperClassName, buttonContainerClassName} = this.props;

    if (removeDom) {
      return null;
    }
    return (
      <div className={cx({[s.desktop]: !isMobile}, s.feedbackContainer, className)} data-hbus={DataSet.createFeedbackViewDataForDavinci(pageTypeForDavinci, pageValueForDavinci)}>
        <div className={cx(s.feedbackRelativeContainer, wrapperClassName)}>
          <span className={s.information}>
            {
              showCheckMark &&
              <HbIcon className={s.checkmark} contentClassName={s.contentCheckmark} />
            }
            <strong>{infoText}</strong>
          </span>

          {showFeedbackButtons &&
            <span className={buttonContainerClassName}>
              <HbButton className={s.feedbackButton} onClick={this.positiveFeedback} dataHbus={this.sendGoogleAnalytics(FEEDBACK_TYPES.EVET)} text={FEEDBACK_TYPES.EVET} />
              <HbButton className={s.feedbackButton} onClick={this.negativeFeedback} dataHbus={this.sendGoogleAnalytics(FEEDBACK_TYPES.HAYIR)} text={FEEDBACK_TYPES.HAYIR} />
            </span>
          }

          {showFeedbackArea && <div className={s.cancel} onClick={this.cancelComment}></div>}

          {showFeedbackArea &&
            <HbReview
              isMobile={isMobile}
              displayErrorMessage={displayErrorMessage}
              errorMessages={errorMessages}
              maxLength={FEEDBACK_VALIDATIONS.MAX_DESCRIPTION_LENGTH}
              onKeyUp={this.updateValue}
              letterCount={letterCount}
              sendButtonHbus={this.sendGoogleAnalytics(FEEDBACK_TYPES.SEND)}
              sendButtonOnClick={this.sendFeedback}
              sendButtonText={FEEDBACK_TYPES.SEND} />
          }
        </div>
      </div>
    );
  }
}

export default Feedback;
